import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Observable, Subject, combineLatest } from 'rxjs';

import { CommandRelay } from 'src/main/angular/app/shared/commands/command-relay.class';

import { AccesTLR } from '../entities/acces-tlr.entity';
import { MotifRefus } from '../entities/motif-refus.entity';

import { MotifRefusService } from '../services/motif-refus.service';
import { AccesService } from '../services/acces.service';

@Component({
	selector: 'acces-refus',
	templateUrl: 'acces-refus.html',
	styleUrls: ['acces-refus.css'],
})
export class AccesRefusComponent {

	// Gestion globale de la fenetre
	displaySubject = new Subject<boolean>();
	
	motifsRefus$!: Observable<MotifRefus[]>;
	
	acces!: AccesTLR[];
	motifRefus!: MotifRefus | null;
	
	constructor(
		@Inject(AccesService) private accesService: AccesService,
		@Inject(MotifRefusService) motifRefusService: MotifRefusService) {
			
		// Chargement des motifs de refus
		this.motifsRefus$ = motifRefusService.getList()

	}

	@Input() id = 'accesRefusDialog';
	
	// Liaison de l'observable servant a commander l'affichage du panneau
	private openRelay = new CommandRelay<number[]>(accesIds => this.open(accesIds));
	@Input() set displayCommands(obs: Observable<number[]> | undefined) {
		this.openRelay.register(obs);
	}

	open(accesId: number[]) {
		let data$ = accesId.map($ => this.accesService.getById($));
		
		combineLatest(data$).subscribe(
			(data) => {
				this.acces = data;
				// affichage de la pop-up
				this.displaySubject.next(true);
			}
		);
	}

	// Decision de sortie
	@Output() decisionIssued = new EventEmitter<[AccesTLR[], number]>();

	onCloseRequested() {
		this.displaySubject.next(false);
		this.decisionIssued.emit([this.acces, -1]);
		this.motifRefus = null;
	}
	
	onAnnulationRequested() {
		this.displaySubject.next(false);
		this.decisionIssued.emit([this.acces, this.motifRefus ? this.motifRefus.id : -1]);
		this.motifRefus = null;
	}
	
	getNumeroAcces() {
		return this.acces ? this.acces.map($ => $.numero).join(', ') : '';
	}
}